export default {
  completion: '{{percent}}% completado',
  pagesValidationProgress: '{{valid}}/{{total}} páginas válidas ({{percent}}%)',
  pageComplete: 'Completa',
  copyPath: 'Copiar ruta',
  pathCopiedToClipboard: 'Ruta copiada al portapapeles',
  subPage: 'Subpágina',
  addChildTo: 'Agregar a {{nodeDefLabel}}',
  addChildToTitle: 'Agregar nuevo nodo a {{nodeDefLabel}}',
  addChildToTypes: {
    boolean: 'Booleano',
    code: 'Código',
    coordinate: 'Coordenada',
    date: 'Fecha',
    decimal: 'Decimal',
    geo: 'Geoespacial',
    entity: 'Tabla o formulario',
    file: 'Archivo',
    integer: 'Entero',
    taxon: 'Taxón',
    text: 'Texto',
    time: 'Hora',
    // layout elments
    formHeader: 'Encabezado de formulario',
  },
  clone: `Clonar '{{nodeDefLabel}}'`,
  compressFormItems: `Comprimir elementos de formulario para '{{nodeDefLabel}}'`,
  confirmClearNonApplicableValues: `Los siguientes campos ya no serán relevantes y sus valores se borrarán:

{{nodeDefLabels}}

¿Continuar?`,
  confirmUpdateDependentEnumeratedEntities: `Si continúa, algunas entidades enumeradas ({{entityDefs}}) se volverán a enumerar, 
eliminando los valores existentes insertados en ellas (si los hay). 
¿Continuar?`,
  convert: `Convertir '{{nodeDefLabel}}'`,
  delete: `Eliminar '{{nodeDefLabel}}'`,
  edit: `Editar '{{nodeDefLabel}}'`,
  schemaSummary_csv: 'Resumen del esquema (CSV)',
  schemaSummary_xlsx: 'Resumen del esquema (Excel)',
  schemaSummaryAiDescriptions_csv: 'Resumen del esquema + descripciones IA (CSV)',
  schemaSummaryAiDescriptions_xlsx: 'Resumen del esquema + descripciones IA (Excel)',
  hidePages: 'Ocultar páginas',
  showPages: 'Mostrar páginas',
  move: `Mover '{{nodeDefLabel}}'`,
  movePageUp: 'Mover página hacia arriba',
  movePageDown: 'Mover página hacia abajo',
  formEditActions: {
    preview: 'Vista previa',
    previewDesktop: 'Vista previa (escritorio)',
    previewMobile: 'Vista previa (móvil)',
    previewOptions: 'Opciones de vista previa',
  },
  mobilePreview: {
    device: {
      phone: 'Teléfono',
      tablet: 'Tableta',
    },
    error: 'Error al cargar la vista previa móvil: {{error}}',
    differences: `**Diferencias con Arena Mobile en un dispositivo real**
- **Fecha y hora**: se escriben en un campo de texto (DD/MM/YYYY, HH:mm) en lugar de los selectores de fecha/hora del dispositivo
- **Mapas**: no disponibles (los botones de mapa muestran un marcador de posición; sin mapas sin conexión ni PDF)
- **Ubicación**: obtenida del navegador (generalmente menos precisa que el GPS del dispositivo); sin receptores GPS externos
- **Fotos y archivos**: seleccionados desde el ordenador; sin captura con cámara ni ubicación de la foto (EXIF)
- **Teclado y gestos**: teclado físico y ratón en lugar del teclado en pantalla y los deslizamientos
- **Datos**: solo en memoria, se pierden al recargar; sin lista de registros, sincronización ni exportación`,
    note: 'Aproximación de Arena Mobile ejecutándose en el navegador con la encuesta en borrador.',
    orientation: {
      landscape: 'Horizontal',
      portrait: 'Vertical',
    },
    reload: 'Recargar',
    title: 'Vista previa móvil',
  },
  formEntryActions: {
    confirmDemote: '¿Está seguro de que desea degradar este registro a {{name}}?',
    confirmPromote: `¿Está seguro de que desea **promover este registro a {{name}}**? 
Ya no podrá editarlo`,
    confirmPromoteWithErrors: `**Este registro contiene errores**. 
Confirmar promoción`,
    confirmDelete: '¿Está seguro de que desea eliminar este registro?\n\nNo se puede deshacer la advertencia',
    closePreview: 'Cerrar vista previa',
    demoteTo: 'Degradar a {{stepPrev}}',
    promoteTo: 'Promover a {{stepNext}}',
    step: 'Paso {{id}} ({{name}})',
  },
  nodeDefEditFormActions: {
    columns: 'Columnas',
    confirmConvert: '¿Convertir el atributo "{{name}}" en "{{toType}}"?',
    confirmDelete:
      '¿Está seguro de que desea eliminar permanentemente esta definición de nodo: {{ name }}?\n\nNo se puede deshacer la advertencia',
  },
  nodeDefCode: {
    code: 'Código',
    label: 'Etiqueta',
    typeCodeOrLabel: 'Escriba código o etiqueta',
    option: 'Opción {{value}}',
  },
  nodeDefBoolean: {
    labelValue: {
      trueFalse: {
        true: 'Verdadero',
        false: 'Falso',
      },
      yesNo: {
        true: 'Sí',
        false: 'No',
      },
    },
  },
  nodeDefCoordinate: {
    coordinate: 'Coordenada',
    srs: 'SRS',
    x: 'X',
    y: 'Y',
    showOnMap: 'Mostrar en el mapa',
    accuracy: 'Precisión',
    altitude: 'Altitud',
    altitudeAccuracy: 'Precisión de altitud',
  },
  nodeDefGeo: {
    confirmDelete: '¿Eliminar este valor geoespacial?',
    geoJSON: 'GeoJSON',
    invalidGeoJsonFileUploaded: 'Archivo GeoJSON no válido cargado',
  },
  nodeDefEntityForm: {
    addNewEntity: 'Agregar nuevo {{name}}',
    confirmDelete: '¿Está seguro de que desea eliminar esta entidad?',
    select: 'Seleccione un(a) {{name}}:',
    selectedEntity: '{{name}} seleccionado(a):',
  },
  nodeDefTaxon: {
    code: 'Código',
    scientificName: 'Nombre científico',
    vernacularName: 'Nombre vernáculo',
    vernacularNameAlwaysIncludedIfSingle: 'Nombre vernáculo siempre incluido si solo hay uno',
    vernacularNameAlwaysIncludedIfSingleInfo: `- **Activado**: si esta opción está activada y un taxón tiene definido un solo nombre vernáculo, ese nombre vernáculo se almacenará automáticamente con los datos cuando se seleccione el taxón.  
- **Desactivado**: solo se almacenarán el código del taxón y el nombre científico, incluso si el taxón tiene un solo nombre vernáculo.`,
    vernacularNameSelectionKept: 'Selección de nombre vernáculo mantenida',
    vernacularNameSelectionKeptInfo: `- **Activado**: cuando se selecciona un taxón usando un nombre vernáculo (común), también se almacenará en los datos el nombre vernáculo específico usado para la búsqueda.  
- **Desactivado**: solo se almacenarán el código del taxón y el nombre científico, sin importar qué nombre vernáculo se haya usado durante la búsqueda.  
En Arena Mobile:  
- **Activado**: cada nombre vernáculo aparece como un elemento separado en la lista de resultados de búsqueda.
- **Desactivado**: todos los nombres vernáculos de un taxón se agrupan y se muestran junto al taxón (combinados en una sola entrada). Como resultado, la lista de autocompletado contiene menos elementos.`,
    visibleFields: 'Campos visibles',
  },
  nodeDefFile: {
    errorLoadingPreview: 'Error al cargar la vista previa',
    fileUuid: 'Uuid del archivo',
    fileName: 'Nombre del archivo',
    locationInformationNotFound: 'Información de ubicación no encontrada en el archivo',
  },
  nodeDefsTreeSelectMode: {
    allNodeDefs: 'Todos los nodos',
    onlyPages: 'Solo páginas',
  },
  step: {
    entry: 'Entrada',
    cleansing: 'Limpieza',
    analysis: 'Análisis',
  },
  cloneFromAnotherSurvey: {
    title: 'Clonar nodo desde otro formulario',
    expandToLoadNodes: 'Expandir para cargar nodos',
    loadingSurveyNodes: 'Cargando nodos del formulario...',
    errorLoadingSurveyNodes: 'Error al cargar los nodos del formulario',
    noNodesAvailable: 'No hay nodos disponibles',
    loadingSurveys: 'Cargando formularios...',
    noSurveysAvailable: 'No hay formularios disponibles',
    sourceNode: 'Nodo de origen',
    targetEntityCurrentSurvey: 'Entidad de destino (formulario actual)',
  },
  confirmNodeDelete: '¿Está seguro de que desea eliminar este {{nodeDefType}} ({{nodeDefLabel}})?',
  downloadPrintableDocument: 'Descargar documento imprimible (Word)',
  downloadPrintableDocumentPdf: 'Descargar documento imprimible (PDF)',
  printableExport: {
    title: 'Exportar documento imprimible',
    exportDocument: 'Exportar documento',
    format: 'Formato',
    formats: {
      pdf: 'PDF',
      docx: 'Word',
    },
    scope: 'Contenido',
    scopes: {
      full: 'Encuesta completa',
      currentPage: 'Solo página actual ({{entityLabel}})',
    },
    currentPageUnavailable:
      'No se puede determinar la instancia de la página actual. Navegue a una página específica o exporte la encuesta completa.',
    includeQrCode: 'Incluir código QR',
    includeQrCodeInfo:
      'Añade un código QR en la primera página que enlaza a una copia de solo lectura del PDF de esta entidad (válido 1 año).',
    orientation: 'Orientación de página',
    orientations: {
      portrait: 'Vertical',
      landscape: 'Horizontal',
    },
    download: 'Descargar',
  },
  exportLabels_csv: 'Exportar etiquetas (CSV)',
  exportLabels_xlsx: 'Exportar etiquetas (Excel)',
  importLabels: 'Importar etiquetas desde Excel o CSV',
  aiTranslateLabels: 'IA: Traducir etiquetas',
  nodeDefsTranslation: {
    apply: 'Aplicar traducciones',
    applySuccess: 'Traducciones aplicadas correctamente',
    aiSuggestion: 'IA',
    current: 'Actual',
    custom: 'Personalizado',
    defaultDescription: 'Descripción por defecto',
    defaultLabel: 'Etiqueta por defecto',
    path: 'Ruta',
    showDescriptions: 'Mostrar descripciones',
    title: 'Traducir etiquetas de definiciones de nodos',
  },
}
